import * as React from 'react';
import { useContext, useEffect } from 'react';
import { FieldsMappingContext } from '../../Context';
import { ProfileTeaserDataFields } from '../../../data-mapping';

export default function (props) {
  const { profileTeaser } = useContext(FieldsMappingContext);
  const [data, setData] = profileTeaser;

  useEffect(() => {
    if (data === undefined) {
      setData(ProfileTeaserDataFields)
    }
  }, [data]);

  if (!data) {
    return null;
  }

  return (
    <>
      <div className="label">Profile image URL</div>
      <div className="form-element">
        <input type="text" value={data.profile_image_url} onChange={e => setData({ ...data, profile_image_url: e.target.value })} />
      </div>

      <div className="label">Links</div>
      <div className="form-element">
        <input type="text" value={data.links} onChange={e => setData({ ...data, links: e.target.value })} />
      </div>

      <div className="label">Title</div>
      <div className="form-element">
        <input type="text" value={data.title} onChange={e => setData({ ...data, title: e.target.value })} />
      </div>

      <div className="label">Job role</div>
      <div className="form-element">
        <input type="text" value={data.job_role} onChange={e => setData({ ...data, job_role: e.target.value })} />
      </div>

      <div className="label">Location</div>
      <div className="form-element">
        <input type="text" value={data.location ?? ''} onChange={e => setData({ ...data, location: e.target.value })} />
      </div>

      <div className="label">Extra fields</div>
      <div className="form-element">
        <textarea value={data.extra_fields ?? ''} onChange={e => setData({ ...data, extra_fields: e.target.value })}></textarea>
        <p className="inline-hints">One index field name per line (e.g. affiliation).</p>
      </div>

      <div className="label">Extra field labels</div>
      <div className="form-element">
        <textarea value={data.extra_field_labels ?? ''} onChange={e => setData({ ...data, extra_field_labels: e.target.value })}></textarea>
        <p className="inline-hints">One label per line; order must match the field names above.</p>
      </div>

      <div className="label">Specialization</div>
      <div className="form-element">
        <input type="text" value={data.specialization} onChange={e => setData({ ...data, specialization: e.target.value })} />
      </div>

      <div className="label">Institution name</div>
      <div className="form-element">
        <input type="text" value={data.institution_name} onChange={e => setData({ ...data, institution_name: e.target.value })} />
      </div>

      <div className="label">Profile page URL</div>
      <div className="form-element">
        <input type="text" value={data.profile_page_url} onChange={e => setData({ ...data, profile_page_url: e.target.value })} />
      </div>
    </>
  );
}
